export enum SortOptionKey {
  Relevance = 'Relevance',
  CreatedNewestToOldest = 'CreatedNewestToOldest',
  CreatedOldestToNewest = 'CreatedOldestToNewest',
  DateCreatedNewestToOldest = 'DateCreatedNewestToOldest',
  DateCreatedOldestToNewest = 'DateCreatedOldestToNewest',
  DeadlineNewestToOldest = 'DeadlineNewestToOldest',
  DeadlineOldestToNewest = 'DeadlineOldestToNewest',
  DueDateNewestToOldest = 'DueDateNewestToOldest',
  DueDateOldestToNewest = 'DueDateOldestToNewest',
  DateOccurredNewestToOldest = 'DateOccurredNewestToOldest',
  DateOccurredOldestToNewest = 'DateOccurredOldestToNewest',
  GeneratedByAToZ = 'GeneratedByAToZ',
  GeneratedByZToA = 'GeneratedByZToA',
  IdentifiedNewestToOldest = 'IdentifiedNewestToOldest',
  IdentifiedOldestToNewest = 'IdentifiedOldestToNewest',
  ReferenceAToZ = 'ReferenceAToZ',
  ReferenceZToA = 'ReferenceZToA',
  SignOffNewestToOldest = 'SignOffNewestToOldest',
  SignOffOldestToNewest = 'SignOffOldestToNewest',
  DateCompletedNewestToOldest = 'DateCompletedNewestToOldest',
  DateCompletedOldestToNewest = 'DateCompletedOldestToNewest',
  BusinessNameAToZ = 'BusinessNameAToZ',
  BusinessNameZToA = 'BusinessNameZToA',
  CategoryAToZ = 'CategoryAToZ',
  CategoryZToA = 'CategoryZToA',
  SubCategoryAToZ = 'SubCategoryAToZ',
  SubCategoryZToA = 'SubCategoryZToA',
  LocationAToZ = 'LocationAToZ',
  LocationZToA = 'LocationZToA',
  CreatedDateNewestToOldest = 'CreatedDateNewestToOldest',
  CreatedDateOldestToNewest = 'CreatedDateOldestToNewest',
  DateIssuedNewestToOldest = 'DateIssuedNewestToOldest',
  DateIssuedOldestToNewest = 'DateIssuedOldestToNewest',
  VersionHighestToLowest = 'VersionHighestToLowest',
  VersionLowestToHighest = 'VersionLowestToHighest',
  NameAToZ = 'NameAToZ',
  NameZToA = 'NameZToA',
  DocumentTypeAToZ = 'DocumentTypeAToZ',
  DocumentTypeZToA = 'DocumentTypeZToA',
  ArrivedDateNewestToOldest = 'ArrivedDateNewestToOldest',
  ArrivedDateOldestToNewest = 'ArrivedDateOldestToNewest',
  LeaveDateNewestToOldest = 'LeaveDateNewestToOldest',
  LeaveDateOldestToNewest = 'LeaveDateOldestToNewest',
}

export const SortOptionsMap: Record<SortOptionKey, { name: string; value: string }> = {
  [SortOptionKey.Relevance]: {
    name: 'Relevance',
    value: '{"relevance":true,"order":-1}',
  },
  [SortOptionKey.CreatedNewestToOldest]: {
    name: 'Created Order: Newest to Oldest',
    value: '{"key":"_id","order":-1}',
  },
  [SortOptionKey.CreatedOldestToNewest]: {
    name: 'Created Order: Oldest to Newest',
    value: '{"key":"_id","order":1}',
  },
  [SortOptionKey.DateCreatedNewestToOldest]: {
    name: 'Date Created: Newest to Oldest',
    value: '{"key":"_id","order":-1}',
  },
  [SortOptionKey.DateCreatedOldestToNewest]: {
    name: 'Date Created: Oldest to Newest',
    value: '{"key":"_id","order":1}',
  },
  [SortOptionKey.CreatedDateNewestToOldest]: {
    name: 'Created Date: Newest to Oldest',
    value: '{"key":"dateCreated","order":-1}',
  },
  [SortOptionKey.CreatedDateOldestToNewest]: {
    name: 'Created Date: Oldest to Newest',
    value: '{"key":"dateCreated","order":1}',
  },
  [SortOptionKey.DeadlineNewestToOldest]: {
    name: 'Deadline: Newest to Oldest',
    value: '{"key":"dateDue","order":-1}',
  },
  [SortOptionKey.DeadlineOldestToNewest]: {
    name: 'Deadline: Oldest to Newest',
    value: '{"key":"dateDue","order":1}',
  },
  [SortOptionKey.DueDateNewestToOldest]: {
    name: 'Due Date: Newest to Oldest',
    value: '{"key":"dateDue","order":-1}',
  },
  [SortOptionKey.DueDateOldestToNewest]: {
    name: 'Due Date: Oldest to Newest',
    value: '{"key":"dateDue","order":1}',
  },
  [SortOptionKey.DateOccurredNewestToOldest]: {
    name: 'Date of Incident: Newest to Oldest',
    value: '{"key":"dateOccurred","order":-1}',
  },
  [SortOptionKey.DateOccurredOldestToNewest]: {
    name: 'Date of Incident: Oldest to Newest',
    value: '{"key":"dateOccurred","order":1}',
  },
  [SortOptionKey.GeneratedByAToZ]: {
    name: 'Generated By: A to Z',
    value: '{"key":"category","order":1}',
  },
  [SortOptionKey.GeneratedByZToA]: {
    name: 'Generated By: Z to A',
    value: '{"key":"category","order":-1}',
  },
  [SortOptionKey.IdentifiedNewestToOldest]: {
    name: 'Identified Date: Newest to Oldest',
    value: '{"key":"dateIdentified","order":-1}',
  },
  [SortOptionKey.IdentifiedOldestToNewest]: {
    name: 'Identified Date: Oldest to Newest',
    value: '{"key":"dateIdentified","order":1}',
  },
  [SortOptionKey.ReferenceAToZ]: {
    name: 'Reference: A to Z',
    value: '{"key":"reference","order":1}',
  },
  [SortOptionKey.ReferenceZToA]: {
    name: 'Reference: Z to A',
    value: '{"key":"reference","order":-1}',
  },
  [SortOptionKey.SignOffNewestToOldest]: {
    name: 'Sign Off: Newest to Oldest',
    value: '{"key":"dateSignedoff","order":-1}',
  },
  [SortOptionKey.SignOffOldestToNewest]: {
    name: 'Sign Off: Oldest to Newest',
    value: '{"key":"dateSignedoff","order":1}',
  },
  [SortOptionKey.DateCompletedNewestToOldest]: {
    name: 'Date Completed: Newest to Oldest',
    value: '{"key":"dateCompleted","order":-1}',
  },
  [SortOptionKey.DateCompletedOldestToNewest]: {
    name: 'Date Completed: Oldest to Newest',
    value: '{"key":"dateCompleted","order":1}',
  },
  [SortOptionKey.BusinessNameAToZ]: {
    name: 'Business Name: A to Z',
    value: '{"key":"businessName","order":1}',
  },
  [SortOptionKey.BusinessNameZToA]: {
    name: 'Business Name: Z to A',
    value: '{"key":"businessName","order":-1}',
  },
  [SortOptionKey.CategoryAToZ]: {
    name: 'Category: A to Z',
    value: '{"key":"category","order":1}',
  },
  [SortOptionKey.CategoryZToA]: {
    name: 'Category: Z to A',
    value: '{"key":"category","order":-1}',
  },
  [SortOptionKey.SubCategoryAToZ]: {
    name: 'Sub category: A to Z',
    value: '{"key":"subcategory","order":1}',
  },
  [SortOptionKey.SubCategoryZToA]: {
    name: 'Sub category: Z to A',
    value: '{"key":"subcategory","order":-1}',
  },
  [SortOptionKey.LocationAToZ]: {
    name: 'Location: A to Z',
    value: '{"key":"location","order":1}',
  },
  [SortOptionKey.LocationZToA]: {
    name: 'Location: Z to A',
    value: '{"key":"location","order":-1}',
  },
  [SortOptionKey.DateIssuedNewestToOldest]: {
    name: 'Issue Date: Newest to Oldest',
    value: '{"key":"dateIssued","order":-1}',
  },
  [SortOptionKey.DateIssuedOldestToNewest]: {
    name: 'Issue Date: Oldest to Newest',
    value: '{"key":"dateIssued","order":1}',
  },
  [SortOptionKey.VersionHighestToLowest]: {
    name: 'Version Number: Highest to Lowest',
    value: '{"key":"vNumber","order":-1}',
  },
  [SortOptionKey.VersionLowestToHighest]: {
    name: 'Version Number: Lowest to Highest',
    value: '{"key":"vNumber","order":1}',
  },
  [SortOptionKey.NameAToZ]: {
    name: 'Name: A to Z',
    value: '{"key":"name","order":1}',
  },
  [SortOptionKey.NameZToA]: {
    name: 'Name: Z to A',
    value: '{"key":"name","order":-1}',
  },
  [SortOptionKey.DocumentTypeAToZ]: {
    name: 'Generated By: A to Z',
    value: '{"key":"category","order":1}',
  },
  [SortOptionKey.DocumentTypeZToA]: {
    name: 'Generated By: Z to A',
    value: '{"key":"category","order":-1}',
  },
  [SortOptionKey.ArrivedDateNewestToOldest]: {
    name: 'Date/Time Arrived: Newest to Oldest',
    value: '{"key":"arriveDate","order":-1}',
  },
  [SortOptionKey.ArrivedDateOldestToNewest]: {
    name: 'Date/Time Arrived: Oldest to Newest',
    value: '{"key":"arriveDate","order":1}',
  },
  [SortOptionKey.LeaveDateNewestToOldest]: {
    name: 'Leave Date/Time: Newest to Oldest',
    value: '{"key":"leaveDate","order":-1}',
  },
  [SortOptionKey.LeaveDateOldestToNewest]: {
    name: 'Leave Date/Time: Oldest to Newest',
    value: '{"key":"leaveDate","order":1}',
  },
};

export const getSortOptions = (keys: SortOptionKey[]): { name: string; value: string }[] => {
  return keys.map((key) => SortOptionsMap[key]);
};

export enum StatusCustomOptionKey {
  Approved = 'Approved',
  Screening = 'Screening',
  Declined = 'Declined',
}

export const StatusOptionsMap: Record<StatusCustomOptionKey, { name: string; value: string }> = {
  [StatusCustomOptionKey.Approved]: {
    name: 'Approved',
    value: 'approved',
  },
  [StatusCustomOptionKey.Screening]: {
    name: 'Screening',
    value: 'screening',
  },
  [StatusCustomOptionKey.Declined]: {
    name: 'Declined',
    value: 'declined',
  },
};

export const getStatusOptions = (
  keys: StatusCustomOptionKey[]
): { name: string; value: string }[] => {
  return keys.map((key) => StatusOptionsMap[key]);
};
